export default "__VITE_ASSET__zahE9VIj__"